const doesFileExist = (path) => (
  new Promise((resolve, reject) => {
    fetch(path)
      .then((response) => {
        if (response.ok) {
          resolve(true);
        }

        resolve(false);
      })
      .catch((error) => {
        reject(error);
      });
  })
);

export default doesFileExist;
